import { Quote, Linkedin, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PILLARS_ABOUT, CAREER } from "../content";

const FounderCard = () => {
  return (
    <div className="relative overflow-hidden rounded-md border border-white/10 bg-[#111519]" data-testid="founder-card">
      <div className="flex items-end gap-6 p-6 sm:p-8 pb-0 sm:pb-0">
        <div className="relative aspect-[4/5] w-[44%] sm:w-[40%] shrink-0 overflow-hidden rounded-md border border-white/10 bg-white">
          <img
            src="/images/anuj.png"
            alt="Anuj Saraswat, Founder & Partner, PLUK HR"
            className="absolute inset-0 h-full w-full object-contain object-bottom"
            data-testid="founder-photo"
          />
        </div>
        <div className="pb-1">
          <span className="block h-px w-12 bg-emerald-400" />
          <p className="font-display mt-4 text-3xl sm:text-4xl leading-none" data-testid="founder-name">Anuj Saraswat</p>
          <p className="mt-3 font-mono text-[11px] tracking-[0.2em] uppercase text-emerald-300">Founder & Partner · PLUK HR</p>
          <a
            href="https://www.linkedin.com/in/anujvsaraswat"
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm text-zinc-200 transition-colors hover:border-emerald-400 hover:text-emerald-300"
            data-testid="founder-linkedin-link"
          >
            <Linkedin className="h-4 w-4 text-emerald-400" />
            <span className="whitespace-nowrap"><span className="hidden sm:inline">Connect on </span>LinkedIn</span>
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
      <div className="p-6 sm:p-8">
        <Quote className="h-5 w-5 text-emerald-400" />
        <p className="font-display mt-3 text-2xl sm:text-3xl italic leading-snug text-zinc-100">
          Industry experience. People insight. Better hiring outcomes.
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6 border-t border-white/10 pt-6">
          <div>
            <p className="eyebrow">BFSI leadership</p>
            <p className="mt-2 text-sm text-zinc-300 leading-relaxed">Banking, fintech, payments, digital banking and financial inclusion.</p>
          </div>
          <div>
            <p className="eyebrow">Business building</p>
            <p className="mt-2 text-sm text-zinc-300 leading-relaxed">Strategy, P&L, product, partnerships, transformation and team building.</p>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap gap-2">
          {CAREER.map((c) => (
            <span key={c} className="rounded-full border border-white/10 px-3 py-1 text-xs text-zinc-300">{c}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export const About = () => (
  <section id="about" className="relative py-28 md:py-40" data-testid="about-section">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-6">
        <SectionHead
          index="01"
          label="About PLUK HR"
          title={<>A new-age search partner with <em className="text-emerald-400">deep industry</em> roots.</>}
          sub="At PLUK, we help BFSI organisations and ambitious startups find, assess and retain exceptional leaders, at every level that matters."
        />
        <div className="mt-14 divide-y divide-white/10 border-y border-white/10">
          {PILLARS_ABOUT.map((p, i) => (
            <Reveal key={p.t} delay={i * 0.08} className="group grid grid-cols-12 gap-4 py-7">
              <span className="col-span-2 font-mono text-xs text-zinc-400 pt-1.5">0{i + 1}</span>
              <div className="col-span-10">
                <p className="font-display text-2xl text-zinc-100 transition-colors group-hover:text-emerald-300">{p.t}</p>
                <p className="mt-2 text-sm md:text-base text-zinc-400 leading-relaxed">{p.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <div className="lg:col-span-6 lg:pt-24">
        <Reveal>
          <FounderCard />
        </Reveal>
      </div>
    </div>
  </section>
);
